import { Component } from '@angular/core';
import { UserConnectionComponent } from '../../user-connection/user-connection.component';

@Component({
  selector: 'pvmo-header',
  templateUrl: './header.component.html',
  imports: [UserConnectionComponent]
})
export class HeaderComponent {}
